import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiEndPoints, PromotionApiEndPoints, StoreApiEndPoints } from './../../app.config';
import { HttpService } from './../../shared/http/http.service';

@Injectable({
  providedIn: 'root'
})
export class StoreService {
  searchText = '';
  private web_url: string = StoreApiEndPoints.apiEndpoint;
  private promotionUrl: string = PromotionApiEndPoints.apiEndpoint;
  private app_url: string = ApiEndPoints.apiEndpoint

  constructor(
    private mock: HttpClient,
    private http: HttpService
  ) { 
}
  getInactiveStore(page, search_value, id, org): Observable<any> {
    if (search_value === null){
      search_value = ''
    }
    return this.http.get(this.web_url+'inactive-stores/?page='+page+'&search='+search_value+'&filter_by='+id+'&platform_type='+org)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // get inactive stores based on their ids
  getStoresByIds(ids, page): Observable<any> {
    return this.http.get(this.web_url+'store-by-selection/?page='+page+'&store_ids='+ids)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getPromotionStores(retailerId, promotionId, search, page): Observable<any> {
    return this.http.get(this.web_url+'retailer-stores-with-promotion/'+retailerId+'/?promotion_id='+promotionId+'&search='+search+'&page='+page)
      .map(this.extractData)
      .catch(this.handleError);
  }


  removeStorePromotion(data): Observable<any> {
    return this.http.post(this.promotionUrl+'remove-store-promotion/', data)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getStoreDetail(store_id): Observable<any> {
    return this.http.get(this.web_url+'update-store/'+store_id+'/')
      .map(this.extractData)
      .catch(this.handleError);
  }
  getActiveStoresAll(org): Observable<any> {
    return this.http.get(this.web_url+'active-all-stores/?platform_type='+org)
      .map(this.extractData)
      .catch(this.handleError);
  }
  getSalesrepresentative(filter_type, timeFilter='', org): Observable<any> {
    return this.http.get(this.app_url+'salesrepresentative/?filter_type='+filter_type+'&time_filter='+timeFilter+'&platform_type='+org)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getStoreCount(user_id='', org): Observable<any> {
    if (user_id != ''){
      return this.http.get(this.web_url+'stores-count/?user_id='+user_id)
      .map(this.extractData)
      .catch(this.handleError);
    }else{
      return this.http.get(this.web_url+'stores-count/?platform_type='+org)
      .map(this.extractData)
      .catch(this.handleError);
    }
    
  }

  updateStoreDetail(store_id, store_data): Observable<any> {
    return this.http.patch(this.web_url+'update-store/'+store_id+'/', store_data)
      .map(this.extractData)
      .catch(this.handleError);
  }

  deregisterStore(storeId, data): Observable<any> {
    return this.http.patch(this.web_url+'deregister-stores/'+storeId+'/', data)
      .map(this.extractData)
      .catch(this.handleError);
  }

  activateStore(retailer_id): Observable<any> {
    return this.http.patch(this.web_url+'retailer-store-activate/'+retailer_id+'/', {})
      .map(this.extractData)
      .catch(this.handleError);
  }

  removeCompany(retailer_id): Observable<any> {
    return this.http.delete(this.web_url+'remove-company-stores/'+retailer_id+'/')
      .map(this.extractData)
      .catch(this.handleError);
  }
  

  // add stores to retailer
  addStoresToRetailer(retailerId, promotion_ids) {
    var selectedStores = localStorage.getItem("selected_stores");
    var storeIds = JSON.parse(selectedStores);
    return this.http.post(this.web_url+'add-stores-to-retailer/', {retailer_id: retailerId, store_ids: storeIds, promotion_ids: promotion_ids})
      .map(this.extractData)
      .catch(this.handleError);
  }

  addStoresToNewRetailer(retailerId, promotion_ids) {
    var selectedStores = localStorage.getItem("selected_stores");
    var storeIds = JSON.parse(selectedStores);
    return this.http.post(this.web_url+'add-stores-to-retailer/', {retailer_id: retailerId, store_ids: storeIds, promotion_ids: promotion_ids})
      .map(this.extractData)
      .catch(this.handleError);
  }


  private extractData(res: Response) {
    if (res.ok && res.status === 200) {
      const body = res.json();
      return body || {};
    } else {
      return throwError('Error in api\'s (server)');
    }
  }

  // Handle Errors
  private handleError(error: any) {
    return throwError(error);
  }
}
